import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { ApiConstants } from "../enum/ApiConstants";
import { ChanceGameFeatureConfigData } from "./ChanceGameFeatureConfigData";
import { WinLineFeatureConfigData } from "./WinLineFeatureConfigData";
export class FeatureConfigData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.solidifyWinLineFeatureConfig();
            this.solidifyChanceGameFeatureConfig();
        }
    }
    solidifyWinLineFeatureConfig() {
        const winLines = this.data.getDataObject(ApiConstants.PROPERTY_WIN_LINES);
        this.winLinesConfig = new WinLineFeatureConfigData(winLines);
    }
    solidifyChanceGameFeatureConfig() {
        const chanceGame = this.data.getDataObject(ApiConstants.PROPERTY_MULTIPLIERS);
        this.chanceGameConfig = new ChanceGameFeatureConfigData(chanceGame);
    }
    getWinLineFeatureConfig() {
        return this.winLinesConfig;
    }
    getChanceGameFeatureConfig() {
        return this.chanceGameConfig;
    }
}
//# sourceMappingURL=FeatureConfigData.js.map